import {NgModule} from '@angular/core';

import {MdcFloatingLabel} from './floating-label';

@NgModule({
  exports: [MdcFloatingLabel],
  declarations: [MdcFloatingLabel]
})
export class MdcFloatingLabelModule { }
